import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import FolderCard from '../../../../FolderCard';
import GallectionControlButtons from '../../GallectionControlButtons';
import { PapiGallection } from '@wix/da-papi-types';
import withCurrentSubfolder, {
  WithCurrentSubfolderProps,
} from '../../../_hocs/withCurrentSubfolder';

import s from './ManageableSubfolder.scss';

export interface Props {
  subfolder: PapiGallection;
  existingGallectionNames: string[];
  className?: string;
}

const enhance = compose(withCurrentSubfolder);

type CombinedProps = Props & WithCurrentSubfolderProps;

export const ManageableSubfolder: React.FC<CombinedProps> = ({
  subfolder,
  existingGallectionNames,
  className,
  currentSubfolderId,
  setCurrentSubfolderId,
}) => {
  const isSelected = subfolder.folderId === currentSubfolderId;
  return (
    <FolderCard
      width={128}
      isSelected={isSelected}
      onClick={() => setCurrentSubfolderId(subfolder.folderId)}
      withLink={false}
      className={classnames(s['subfolder-card'], className)}
      key={subfolder.folderId}
      folder={subfolder}
      extras={
        <GallectionControlButtons
          className={classnames(
            s['gallection-control-buttons'],
            isSelected && s['gallection-control-buttons-on-selected']
          )}
          moreMenuClassName={s['gallection-control-menu']}
          gallection={subfolder}
          existingGallectionNames={existingGallectionNames}
        />
      }
    />
  );
};

ManageableSubfolder.displayName = 'ManageableSubfolder';

export default enhance(ManageableSubfolder) as any;
